
import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "https://dashboard.lono.co.in/api";

// Create axios instance with base URL
const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const financialAPI = {
  getFinancialByLoanId: async (loanId) => {
    try {
      const res = await api.get(`/financial/${loanId}`);
      return res.data;
    } catch (err) {
      throw err.response?.data || err.message;
    }
  },

  saveFinancialData: async (loanId, customerId, data) => {
    try {
      const res = await api.post("/financial/save", {
        loanId,
        customerId,
        data,
      });
      return res.data;
    } catch (err) {
      throw err.response?.data || err.message;
    }
  },
};
